export type QueryStatusValue = 'idle' | 'loading' | 'error' | 'success';

export interface QueryStatusBase {
  status: QueryStatusValue;
}

export interface QueryStatusIdle extends QueryStatusBase {
  isError: false;
  isIdle: true;
  isLoading: false;
  isSuccess: false;
  status: 'idle';
}

export interface QueryStatusLoading extends QueryStatusBase {
  isError: false;
  isIdle: false;
  isLoading: true;
  isSuccess: false;
  status: 'loading';
}

export interface QueryStatusError extends QueryStatusBase {
  isError: true;
  isIdle: false;
  isLoading: false;
  isSuccess: false;
  status: 'error';
}

export interface QueryStatusSuccess extends QueryStatusBase {
  isError: false;
  isIdle: false;
  isLoading: false;
  isSuccess: true;
  status: 'success';
}

export type QueryStatus =
  | QueryStatusIdle
  | QueryStatusLoading
  | QueryStatusError
  | QueryStatusSuccess;

export const idle: QueryStatusIdle = {
  isSuccess: false,
  isIdle: true,
  isError: false,
  isLoading: false,
  status: 'idle',
};

export const loading: QueryStatusLoading = {
  isSuccess: false,
  isIdle: false,
  isError: false,
  isLoading: true,
  status: 'loading',
};

export const error: QueryStatusError = {
  isSuccess: false,
  isIdle: false,
  isError: true,
  isLoading: false,
  status: 'error',
};

export const success: QueryStatusSuccess = {
  isSuccess: true,
  isIdle: false,
  isError: false,
  isLoading: false,
  status: 'success',
};

export const queryStatus = {
  idle,
  loading,
  error,
  success,
};
